import { useState, FormEvent } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      navigate('/login?reset=1');
    } catch (err: any) {
      setError(err.message ?? 'Reset failed.');
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="card">
          <h2 className="text-lg font-semibold mb-4">{t('auth.resetTitle')}</h2>
          {error && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2 mb-4">{error}</p>}
          {!token && <p className="text-sm text-red-600">Invalid or missing reset token.</p>}
          {token && (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="label">{t('settings.newPassword')}</label>
                <input className="input" type="password" required minLength={8} value={password}
                  onChange={e => setPassword(e.target.value)} placeholder="Min. 8 characters" />
              </div>
              <button className="btn-primary w-full" type="submit" disabled={loading}>
                {loading ? t('auth.resetting') : t('auth.resetButton')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
